import BusinessIcon from '@mui/icons-material/Business';
import GroupIcon from '@mui/icons-material/Group';
import HelpIcon from '@mui/icons-material/Help';
import HomeIcon from '@mui/icons-material/Home';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PlaceIcon from '@mui/icons-material/Place';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { NavigationItem, ISideNavigation } from '@/components/ui/side-navigation/types';

const HELP_LINK = 'https://www.youtube.com/@Leviant-Cleans/playlists';

const COMMON_PRIMARY_NAVIGATION_ITEMS: NavigationItem[] = [
	{
		itemTitle: 'Dashboard',
		path: '/dashboard',
		icon: <HomeIcon />,
	},
];

const COMMON_SECONDARY_NAVIGATION_ITEMS: NavigationItem[] = [
	{
		itemTitle: 'Device Training Videos',
		icon: <HelpIcon />,
		path: HELP_LINK,
		openInNewTab: true,
	},
];

export const LEVIANT_ADMIN_NAVIGATION_ITEMS: ISideNavigation = {
	primary: [
		...COMMON_PRIMARY_NAVIGATION_ITEMS,
		{
			itemTitle: 'Customers',
			path: '/customers',
			icon: <ManageAccountsIcon />,
		},
		{
			itemTitle: 'Logs',
			path: '/logs',
			icon: <PlayCircleIcon />,
		},
		{
			itemTitle: 'Users',
			path: '/users',
			icon: <GroupIcon />,
		},
	],
	secondary: [...COMMON_SECONDARY_NAVIGATION_ITEMS],
};

export const ACCOUNT_ADMIN_NAVIGATION_ITEMS: ISideNavigation = {
	primary: [
		...COMMON_PRIMARY_NAVIGATION_ITEMS,
		{
			itemTitle: 'Sites',
			path: '/sites',
			icon: <BusinessIcon />,
		},
	],
	secondary: [...COMMON_SECONDARY_NAVIGATION_ITEMS],
};

export const SITE_ADMIN_NAVIGATION_ITEMS: ISideNavigation = {
	primary: [
		...COMMON_PRIMARY_NAVIGATION_ITEMS,
		{
			itemTitle: 'Sites',
			path: '/sites',
			icon: <BusinessIcon />,
		},
	],
	secondary: [...COMMON_SECONDARY_NAVIGATION_ITEMS],
};

export const SITE_SUPERVISOR_NAVIGATION_ITEMS: ISideNavigation = {
	primary: [
		...COMMON_PRIMARY_NAVIGATION_ITEMS,
		{
			itemTitle: 'Locations',
			path: '/locations',
			icon: <PlaceIcon />,
		},
		{
			itemTitle: 'Devices',
			path: '/devices',
			icon: <SettingsApplicationsIcon />,
		},
		{
			itemTitle: 'Users',
			path: '/users',
			icon: <GroupIcon />,
		},
	],
	secondary: [...COMMON_SECONDARY_NAVIGATION_ITEMS],
};

export const OPERATOR_NAVIGATION_ITEMS: ISideNavigation = {
	primary: [
		...COMMON_PRIMARY_NAVIGATION_ITEMS,
	],
	secondary: [...COMMON_SECONDARY_NAVIGATION_ITEMS],
};
